import { Box } from '@mui/system';
import React from 'react';
import LexicaljsEditor from '../../../../lexical/LexicaljsEditor';
import { useI18n } from '../../../../i18n/I18n';
import NoteFormActions from './NoteFormActions';
import NoteTagsInput from './NoteTagsInput';

type CreateNoteFormProps = {
    editorId?: string;
    content: string;
    resetEditor?: boolean;
    onChange: (content: string, title: string) => void;
    tagsValue?: string[];
    onTagsChange: (name: string, value: string[], noteId: string | null) => void;
    onSave: () => void;
    onCancel: () => void;
    onShare?: () => void;
    disableSave?: boolean;
    isSaving?: boolean;
    disabled?: boolean;
    /** Incrementing this value re-triggers auto-focus in the editor */
    focusTrigger?: number;
};

export default function CreateNoteForm({
    editorId = 'new-note',
    content,
    resetEditor = false,
    onChange,
    tagsValue = [],
    onTagsChange,
    onSave,
    onCancel,
    onShare = undefined,
    disableSave = false,
    isSaving = false,
    disabled = false,
    focusTrigger = 0
}: CreateNoteFormProps) {
    const t = useI18n();

    /**
     * @todo
     * This component should eventually directly use `useSecurity` to resolve "comment" permission on the parent
     * entity within the context of which this instance of Notes is being used.
     * It should return null if the user does not have permission to create notes on the parent entity.
     */

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
            <LexicaljsEditor
                id={editorId}
                isSmall={true}
                contentPlaceholder={t('notes.placeholder.content')}
                readOnly={false}
                clearOnSave={false}
                clearOnCancel
                content={content}
                resetEditor={resetEditor}
                onChange={onChange}
                shouldAutoFocus
                focusTrigger={focusTrigger}
                disableTranslation
            />
            <NoteTagsInput value={tagsValue} onChange={onTagsChange} />
            <NoteFormActions
                onSave={onSave}
                isSaving={isSaving}
                onCancel={onCancel}
                disableSave={disableSave}
                onShare={onShare}
                disabled={disabled}
            />
        </Box>
    );
}
